export interface FaqService {
  getLocalizedArticle: (articleSlug: number | string) => string;
  getLocalizedHelpCenter: string;
}

export const faqService: FaqService = {
  getLocalizedArticle: (articleSlug: number | string) => articleSlug.toString(),
  getLocalizedHelpCenter: '',
};
